import { render, staticRenderFns } from "./BatchRunYearWeekLink.vue?vue&type=template&id=3feaaff4&scoped=true"
import script from "./BatchRunYearWeekLink.vue?vue&type=script&lang=js"
export * from "./BatchRunYearWeekLink.vue?vue&type=script&lang=js"
import style0 from "./BatchRunYearWeekLink.vue?vue&type=style&index=0&id=3feaaff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feaaff4",
  null
  
)

export default component.exports